import { useCallback } from 'react';
import { useApolloClient } from '@apollo/client';
import { useModals, ModalNames } from 'components/modals';
import useUser from 'hooks/use-user';

function noop(): void {
  // Swallow clearStore() rejection -- see use-user-button.ts.
}

/**
 * Signs the shopper out and opens the login modal so they can switch to the account that owns
 * their verified phone. Order matters: logout first so no authenticated refetch races the cache
 * clear; clearStore (not resetStore) so nothing eagerly refetches; login modal last.
 */
export function useSwitchToOtherAccount(): () => Promise<void> {
  const User = useUser();
  const apolloClient = useApolloClient();
  const { openModal } = useModals();

  return useCallback(async (): Promise<void> => {
    User.logout();
    await apolloClient.clearStore().catch(noop);
    void openModal(ModalNames.login);
  }, [User, apolloClient, openModal]);
}
